function searchableValue(value) {
  if (value === null || value === undefined) return '';
  if (Array.isArray(value)) return value.map(searchableValue).filter(Boolean).join(' ');
  if (typeof value === 'object') return '';
  return String(value);
}

/**
 * Build a search string from fields Home Assistant may provide on a browse
 * item. Missing source-specific metadata is simply ignored.
 */
export function mediaSearchText(item) {
  return [
    item?.title,
    item?.media_content_id,
    item?.media_content_type,
    item?.media_class,
    item?.country,
    item?.language,
    item?.metadata?.country,
    item?.metadata?.language,
    item?.metadata?.media_class,
  ]
    .map(searchableValue)
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}

export function filterMediaItems(items, query) {
  const source = Array.isArray(items) ? items : [];
  const normalizedQuery = String(query ?? '').trim().toLowerCase();
  if (!normalizedQuery) return source;
  return source.filter(item => mediaSearchText(item).includes(normalizedQuery));
}

export function mediaBrowserEmptyMessage(items, filteredItems) {
  if (!Array.isArray(items) || items.length === 0) return 'No media found';
  if (!Array.isArray(filteredItems) || filteredItems.length === 0) return 'No matching media found';
  return '';
}

export function clearMediaSearchQuery(searchQuery) {
  searchQuery.value = '';
}
